import { useState, useEffect } from 'react'
import { syncEndsAt } from 'services/Whatsapp'

/* true enquanto o histórico do celular ainda está chegando (ver `syncEndsAt`). */
export default function useSyncing(session) {
  const endsAt = syncEndsAt(session)
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    if (!endsAt || endsAt <= Date.now()) return undefined
    const timer = setTimeout(() => setNow(Date.now()), endsAt - Date.now() + 50)
    return () => clearTimeout(timer)
  }, [endsAt])

  return !!endsAt && endsAt > Math.max(now, Date.now())
}
